export const PRODUCT_ACTIONS = {
  EXACT: 'exact',
  MODEL: 'model',
  SKIP: 'skip',
};
